import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useWorkshop } from "../context/useWorkshop";
import { clienteService } from "../services/cadastroService";

const EMPTY = { nome: "", telefone: "", email: "" };

export default function ClientesPage() {
  const { t } = useTranslation();
  const { workshopId } = useWorkshop();
  const [reloadToken, setReloadToken] = useState(0);
  const [editando, setEditando] = useState(null); // null = nenhum, {} = novo
  const [clientes, setClientes] = useState([]);
  const [erro, setErro] = useState("");
  useEffect(() => {
    clienteService.list(workshopId).then(setClientes);
  }, [workshopId, reloadToken]);

  async function salvar(e) {
    e.preventDefault();
    setErro("");
    try {
      await clienteService.save(workshopId, editando);
      setEditando(null);
      setReloadToken((t) => t + 1);
    } catch (err) {
      setErro(err.message || t("checklist.clientes_erro_salvar"));
    }
  }

  async function excluir(id) {
    if (window.confirm(t("checklist.clientes_confirm_excluir"))) {
      try {
        await clienteService.remove(workshopId, id);
        setReloadToken((v) => v + 1);
      } catch (err) {
        setErro(err.message || t("checklist.clientes_erro_excluir"));
      }
    }
  }

  return (
    <div className="page">
      <header className="page__header">
        <h2>{t("checklist.clientes_titulo")}</h2>
        <button className="btn btn--primary" onClick={() => setEditando({ ...EMPTY })}>
          {t("checklist.clientes_novo")}
        </button>
      </header>

      {erro && (
        <div style={{
          background: "#fef2f2", border: "1px solid #fca5a5", color: "#b91c1c",
          borderRadius: 8, padding: "10px 14px", marginBottom: 12, fontSize: 13, fontWeight: 600,
        }}>
          {erro}
        </div>
      )}

      {editando && (
        <form className="form-section" onSubmit={salvar}>
          <div className="form-grid">
            <label>
              {t("checklist.clientes_nome")}
              <input
                required
                value={editando.nome}
                onChange={(e) => setEditando({ ...editando, nome: e.target.value })}
              />
            </label>
            <label>
              {t("checklist.clientes_telefone")}
              <input
                value={editando.telefone}
                onChange={(e) => setEditando({ ...editando, telefone: e.target.value })}
              />
            </label>
            <label>
              {t("checklist.clientes_email")}
              <input
                type="email"
                value={editando.email}
                onChange={(e) => setEditando({ ...editando, email: e.target.value })}
              />
            </label>
          </div>
          <div className="checklist-form__footer">
            <button type="button" className="btn btn--ghost" onClick={() => setEditando(null)}>
              {t("common.cancelar")}
            </button>
            <button type="submit" className="btn btn--primary">
              {t("common.salvar")}
            </button>
          </div>
        </form>
      )}

      {clientes.length === 0 ? (
        <p className="empty-state">{t("checklist.clientes_nenhum")}</p>
      ) : (
        <div className="table-scroll">
          <table className="checklist-table">
          <thead>
            <tr>
              <th>{t("checklist.clientes_nome")}</th>
              <th>{t("checklist.clientes_telefone")}</th>
              <th>{t("checklist.clientes_email")}</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {clientes.map((c) => (
              <tr key={c.id}>
                <td>{c.nome}</td>
                <td>{c.telefone || "—"}</td>
                <td>{c.email || "—"}</td>
                <td>
                  <button className="btn btn--ghost btn--small" onClick={() => setEditando(c)}>
                    {t("common.editar")}
                  </button>
                  <button
                    className="btn btn--ghost btn--small"
                    onClick={() => excluir(c.id)}
                  >
                    {t("common.excluir")}
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        </div>
      )}
    </div>
  );
}
